<div class="grafico-serie">
  @if (listo()) {
    <p-chart [type]="type()" [data]="chartData()" [options]="options()" [style]="{ height: '100%', width: '100%' }" />
  }
</div>
